/* src/app/admin/user/create-or-update-user.component.scss */
.toggle-group {
  display: flex;
  gap: 0;
  border-radius: 10px;
  overflow: hidden;
  border: 1px solid #ebebeb;
  width: fit-content;
}
.toggle-group .toggle-button {
  padding: 8px 24px;
  border: none;
  background-color: #f5f5f5;
  color: #666;
  font-size: 14px;
  font-family: "Noto Sans", sans-serif;
  cursor: pointer;
  transition: background-color 0.2s, color 0.2s;
}
.toggle-group .toggle-button:hover:not(.active) {
  background-color: #e0e0e0;
}
.toggle-group .toggle-button.active {
  background-color: #006f8a;
  color: white;
  font-weight: 600;
}
.sidebar {
  position: relative;
  padding: 0;
  margin: 0;
  font-family: "Noto Sans", sans-serif;
}
.sidebar .search-container {
  display: flex;
  align-items: center;
  margin: 15px 0 30px;
  padding: 0;
  background-color: transparent;
}
.sidebar .search-input {
  flex-grow: 1;
  height: 40px;
  padding: 0 10px;
  border: 1px solid #ebebeb;
  border-radius: 10px;
  box-shadow: 0 8px 16px rgba(0, 0, 0, 0.1);
  outline-color: #006f8a;
  font-size: 14px;
}
.sidebar .search-input::placeholder {
  color: #999;
}
.sidebar .search-input:focus {
  outline: 1px solid;
  outline-offset: -2px;
}
.sidebar .search-button {
  cursor: pointer;
  width: 39px;
  height: 39px;
  margin-left: 2px;
  margin-top: 0;
  border: none;
  border-radius: 10px;
  background-color: #006f8a;
  color: white;
  display: flex;
  align-items: center;
  justify-content: center;
}
.sidebar .search-button:hover {
  background-color: #00576d;
}
.sidebar .panel-list {
  margin-top: 8px;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  font-size: 14px;
  color: #1d1d1d;
}
.sidebar .panel-item {
  display: flex;
  align-items: center;
  margin-bottom: 8px;
  width: 100%;
  max-width: 400px;
  height: 40px;
}
.sidebar .panel-item label {
  margin-right: 16px;
  color: #1d1d1d;
  font-size: 14px;
}
.sidebar .toggle-text {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  font-size: 12px;
  font-weight: bold;
  color: white;
  pointer-events: none;
}
.sidebar .toggle-text.selected {
  color: white;
}
.sidebar .panel-label {
  width: 100%;
}
/*# sourceMappingURL=create-or-update-user.component-IOMZZLVP.css.map */
